import { render, staticRenderFns } from "./PendingLoans.vue?vue&type=template&id=c109d69a&scoped=true&"
import script from "./PendingLoans.vue?vue&type=script&lang=js&"
export * from "./PendingLoans.vue?vue&type=script&lang=js&"
import style0 from "./PendingLoans.vue?vue&type=style&index=0&id=c109d69a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c109d69a",
  null
  
)

export default component.exports